import React, { ComponentProps } from 'react';
import { asFetchableBlock, useInvalidateRefreshableBlock, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DeletableItemList } from '../../_lib/components/DeletableItemList/DeletableItemList';
import ILink from '../../types/ILink';
import { ProfileImageSmall } from '../../types/api/ImageType';
import IUrl from '../../types/IUrl';
import { PersonInformation } from '../../components/molecules/PersonInformation';
import { Namespace } from '../../translation/namespace';
import { SonForm } from '../../_lib/Form2';

type FavoritedUsersProps = {
  items?: {
    id: string;
    content: {
      profileLink: ILink;
      profileImageUrl: ProfileImageSmall;
      personInfoCardUrl: IUrl;
      profileName: string;
    };
    removeForm: SonForm<any>;
  }[];
};

function FavoritedUsers({ items = [] }: FavoritedUsersProps) {
  const { refresh } = useRefreshBlock();
  const invalidateRefreshableBlock = useInvalidateRefreshableBlock();

  return (
    <DeletableItemList
      items={items.map(item => ({ ...item, name: item.content.profileLink.name }))}
      refresh={() => {
        refresh();
        invalidateRefreshableBlock(BlockType.personinteraction);
      }}
      namespaceAndKey={`${Namespace.FavoritedUsers}:deletableItem`}
    >
      {({ content }) => <PersonInformation {...content} />}
    </DeletableItemList>
  );
}
export const FavoritedUsersBlock = asFetchableBlock(FavoritedUsers, BlockType.favoritedusers, BlockType.favoritedusers);
export type FavoritedUsersBlock = ComponentProps<typeof FavoritedUsersBlock>;
